import { functionWithFG } from '@atlaskit/platform-feature-flags-react';
import type { Extension } from '@atlassian/forge-ui/ui';

export const extractStaticViewDefinition = (extension: Extension): any =>
	extension?.properties?.staticView;

const defaultStaticViewProperties = { isContentViewAvailable: false, contentKey: 'default' };

const extractExtensionStaticViewPropertiesImpl = (
	extension: Extension | null,
	properties: Record<string, unknown> | null,
): {
	contentKey: string;
	isContentViewAvailable: boolean;
} => {
	if (!extension || !properties) {
		return defaultStaticViewProperties;
	}

	const staticView = extractStaticViewDefinition(extension);
	if (!staticView) {
		return defaultStaticViewProperties;
	}

	const contentKeyConfigLookupField = staticView.contentTitleConfigKey;
	const contentKey = properties[contentKeyConfigLookupField] as string | null;

	return {
		isContentViewAvailable: !!contentKey,
		contentKey: contentKey ?? defaultStaticViewProperties.contentKey,
	};
};

const defaultImpl = () => defaultStaticViewProperties;

export const extractExtensionStaticViewProperties: (
	extension: Extension | null,
	properties: Record<string, unknown> | null,
) => {
	contentKey: string;
	isContentViewAvailable: boolean;
} = functionWithFG('forge-ui-static-macros', extractExtensionStaticViewPropertiesImpl, defaultImpl);
